import { Component, Input } from '@angular/core';

export interface StateIcon {
    selector: Compliance.AssetChangeStatusEnum;
    iconClass: string;
    active: boolean;
    tooltipTitle: string;
}

@Component({
    selector: 'asset-change-icon',
    styleUrls: ['./assetChangeIcon.component.scss'],
    template: `
        <div class="asset-change-icon">
          <ul class="state-icons">
            @for (icon of activeIcons; track icon) {
              <li helpTooltip [tooltipText]="icon.tooltipTitle">
                @if (icon.active) {
                  <i class="state-icon fa" [ngClass]="icon.iconClass"></i>
                }
              </li>
            }
          </ul>
        </div>
        `,
    standalone: false
})
export class AssetChangeIconComponent {
    @Input()
    set icons(icons: StateIcon[]) {
        this.activeIcons = icons.filter(i => i.active);
    }

    activeIcons: StateIcon[] = [];
}
